import FinalOfferPage from '@components/FinalOfferPage/FinalOfferPage';

const FinalOffer = () => {
  return (
    <>
      <FinalOfferPage />
    </>
  );
};

export default FinalOffer;
